var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5V25H15.1609L30 5.00238H0V5Z",
    fill: "url(#paint0_linear_1770_2516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1232 14.6434H17.4896V11.6397H18.1238C18.9704 11.6397 19.6441 12.0009 19.6441 13.1231C19.6441 14.2822 18.9701 14.6451 18.1238 14.6451M11.2985 16.795C10.9839 16.7967 10.6715 16.7255 10.3762 16.5843L11.2894 12.8503H11.3083L12.2032 16.595C11.913 16.7287 11.6072 16.7968 11.2992 16.7963M17.9559 9.1972H15.075V18.0768L12.5591 9.1972H10.0663L7.91743 16.6195C7.69024 14.751 6.19612 14.1026 5.02071 13.6182C4.24635 13.2909 3.42183 12.8204 3.42908 12.2947C3.4354 11.8651 3.87211 11.4658 4.7323 11.5255C5.31227 11.5636 5.82819 11.6237 6.83889 12.2607L7.84328 10.0015C6.91652 9.38785 5.63255 9.00245 4.58146 9H4.57137C3.34578 9 2.32467 9.51754 1.69136 10.3665C1.25353 10.9503 1.00652 11.7308 1.00189 12.5451C0.985485 13.689 1.3105 14.5007 1.99082 15.1499C2.56606 15.6969 3.30034 16.0484 3.94879 16.3127C4.7487 16.631 5.40157 16.9116 5.394 17.5085C5.38927 17.7262 5.32142 17.9332 5.20404 18.0887C5.00524 18.3546 4.69916 18.4569 4.27538 18.47C3.45906 18.4913 2.85447 18.3268 1.88984 17.5879L1 19.8765C1.99334 20.6081 3.11511 20.9947 4.2574 21H4.40791C5.41766 20.9755 6.2343 20.6011 6.88622 19.9216L6.99225 19.8029L6.70731 20.8012H9.32162L9.76086 19.0689C10.7476 19.483 11.8094 19.4887 12.799 19.0853L13.2218 20.802H17.4889V17.2222H18.4204C20.6687 17.2222 22 15.7387 22 13.2487C22 10.4769 20.7063 9.20538 17.9547 9.20538",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1770_2516",
    x1: 14.8494,
    y1: 5.06377,
    x2: 14.8494,
    y2: 25.2489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#06A5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#1870C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D61BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSap);
export default __webpack_public_path__ + "static/media/HeaderSAP.2cedd89189a11c861b22e8d71692f75c.svg";
export { ForwardRef as ReactComponent };